import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

import { authorSelector } from '~/atomic/page/author/author.selector';
import { getAuthorPosts } from '~/atomic/page/author/blog/authorBlog.data';
import { authorBlogSelector } from '~/atomic/page/author/blog/authorBlog.selector';
import { PageTitleStyle } from '~/atomic/Typography';
import { EmptyPostCard } from '~/feature/blogs/EmptyPostCard';
import { Pagination } from '~/feature/pagination/Pagination';
import { useAppDispatch, useAppSelector } from '~/store';

import { AuthorPostCard } from './AuthorPostCard';

export const AuthorBlog: FC = () => {
  const dispatch = useAppDispatch();
  const { currentAuthor } = useAppSelector(authorSelector);
  const { isGetAuthorPostsLoading, posts } = useAppSelector(authorBlogSelector);

  useEffect(() => {
    dispatch(getAuthorPosts({ username: currentAuthor.username }));
  }, [currentAuthor.username]);

  return (
    <SCBlog>
      <SCTitle>
        Блог автора
        {' '}
        {currentAuthor?.name}
        {' '}
        {!!currentAuthor?.counters?.posts && (
          <>
            (
            {currentAuthor?.counters?.posts}
            )
          </>
        )}

      </SCTitle>
      {isGetAuthorPostsLoading ? (
        <>
          <EmptyPostCard />
          <EmptyPostCard />
          <EmptyPostCard />
        </>
      ) : posts.map((post) => (
        <AuthorPostCard
          key={post.id}
          post={post}
        />
      ))}
      <SCPagination
        onChange={() => {
          dispatch(getAuthorPosts({ username: currentAuthor.username }));
        }}
      />
    </SCBlog>
  );
};

const SCBlog = styled.div`
  width: 100%;
`;

const SCTitle = styled.h1`
  ${PageTitleStyle};
  margin-bottom: 16px;
`;

const SCPagination = styled(Pagination)`
  display: flex;
  justify-content: center;
`;
